module.exports = __webpack_public_path__ + "static/img/iconMadSweeney.0ba9dff.svg";


//////////////////
// WEBPACK FOOTER
// ./static/svg/iconMadSweeney.svg
// module id = Wcup
// module chunks = 1